exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__user-card-header___36ARo{position:relative;display:flex;flex:0 0 auto;height:50%;background-size:cover;background-repeat:no-repeat;background-position:50%;border-radius:.25rem .25rem 0 0}", ""]);

// exports
exports.locals = {
	"user-card-header": "styles__user-card-header___36ARo"
};